import { render, staticRenderFns } from "./AdminModeration.vue?vue&type=template&id=721bedca&scoped=true"
import script from "./AdminModeration.vue?vue&type=script&lang=ts"
export * from "./AdminModeration.vue?vue&type=script&lang=ts"
import style0 from "./AdminModeration.vue?vue&type=style&index=0&id=721bedca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721bedca",
  null
  
)

export default component.exports